import React, { Component } from "react";
import Card from "material-ui/Card";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { resetResults } from "../../../modules/search";
import { changeEnableMap } from "../../../modules/map";
import HeaderCard from "../HeaderCard/HeaderCard";
import "./TutorialCard.css";
import loopIcon from "../../../icons/loop.svg";
import itineraryIcon from "../../../icons/itinerary.svg";
import cities from "../../../config/city";

const styles = () => ({
  button: {
    border: "1px #3f51b5 solid",
    borderRadius: "5px",
    marginTop: "15px"
  }
});
class TutorialCard extends Component {
  constructor() {
    super();
    this.state = {
      shouldOpenDialog: false
    };
  }

  componentWillMount() {
    const currentCity = cities.find(
      city =>
        city.name.toLowerCase() === this.props.city.toLowerCase().substring(1)
    );
    if (!currentCity) {
      this.props.goRoot();
    } else {
      this.props.resetResults();
      this.props.changeEnableMap(false, currentCity);
    }
  }
  handleOpenInfoDialog = () => {
    this.setState({ shouldOpenDialog: true });
  };

  handleCloseInfoDialog = () => {
    this.setState({ shouldOpenDialog: false });
  };

  render() {
    return (
      <div className="main-card">
        <Card>
          <HeaderCard
            isCity
            subtitle={this.props.city.substring(1)}
            openInfoDialog={this.handleOpenInfoDialog}
          />
          <div className={!this.props.menuIsOpen ? "no-display" : ""}>
            <div className="main-content">
              <div className="title-tuto">Quel trajet voulez-vous faire ?</div>
              <div className="opt-action-container">
                <div className="opt-action">
                  <img alt="itinerary" src={itineraryIcon} />
                  <div className="label">
                    Relier deux lieux et déambuler dans la ville
                  </div>
                  <Button
                    onClick={() =>
                      this.props.changePage(this.props.city, "itineraire")
                    }
                    className={this.props.classes.button}
                    color="primary"
                  >
                    Itinéraire
                  </Button>
                </div>
                <div className="opt-action">
                  <img alt="loop" src={loopIcon} />
                  <div className="label">
                    Vous promener sur votre temps libre
                  </div>
                  <Button
                    onClick={() =>
                      this.props.changePage(this.props.city, "boucle")
                    }
                    className={this.props.classes.button}
                    color="primary"
                  >
                    Boucle
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

TutorialCard.propTypes = {
  classes: PropTypes.shape({
    button: PropTypes.string
  }).isRequired,
  changePage: PropTypes.func.isRequired,
  goRoot: PropTypes.func.isRequired,
  changeEnableMap: PropTypes.func.isRequired,
  city: PropTypes.string.isRequired,
  resetResults: PropTypes.func.isRequired,
  menuIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  city: ownProps.match.params.city,
  menuIsOpen: state.search.menuIsOpen
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: (city, action) => push(`/${city}/${action}`),
      goRoot: () => push(`/`),
      changeEnableMap,
      resetResults
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(TutorialCard)
);



// WEBPACK FOOTER //
// ./src/containers/MainCard/TutorialCard/TutorialCard.jsx